import gql from 'graphql-tag';
import { useQuery } from '@apollo/react-hooks';

import { planFragment } from '@zapier/upsells/src/fragments';
import { useCurrentAccountId } from '@zapier/upsells/src/hooks';
import { PlanStacksQuery } from '@zapier/upsells/src/types';

export const planStacksQuery = gql`
  query upsells_planStacksQuery($accountId: Int) {
    planStacks: pricingPageV3Plans(accountId: $accountId) {
      id
      plans {
        ...upsells_planFragment
      }
      planType
    }
  }
  ${planFragment}
`;

type Props = {
  skip?: boolean;
};

export const usePlanStacks = ({ skip = false }: Props = {}) => {
  const {
    accountId,
    isLoading: isLoadingCurrentAccountId,
  } = useCurrentAccountId();

  const { data, error, loading: isLoadingPlanStacks } = useQuery<
    PlanStacksQuery
  >(planStacksQuery, {
    skip: skip || isLoadingCurrentAccountId,
    variables: {
      accountId,
    },
  });

  return {
    error: error?.message,
    isLoading: isLoadingCurrentAccountId || isLoadingPlanStacks,
    planStacks: data?.planStacks ?? [],
  };
};
